import { Link } from 'react-router-dom';

const actions = [
  {
    to: '/students',
    title: '학생 관리카드',
    desc: '학생을 등록하고 진도·시험·교습비를 관리해요',
    icon: 'ri-user-add-line',
  },
  {
    to: '/lessons/new',
    title: '수업일지 작성',
    desc: '오늘 수업 내용과 숙제, 테스트를 기록해요',
    icon: 'ri-edit-2-line',
  },
];

export default function QuickActionsCard() {
  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
      <h2 className="text-base font-bold text-foreground-950">바로 가기</h2>
      <div className="mt-4 flex flex-col gap-3">
        {actions.map((a) => (
          <Link
            key={a.to}
            to={a.to}
            className="group flex items-center gap-3.5 rounded-lg border border-background-200 bg-background-100 p-4 transition hover:border-primary-300"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className={`${a.icon} text-lg`}></i>
            </span>
            <div className="flex-1">
              <p className="text-sm font-semibold text-foreground-950">{a.title}</p>
              <p className="mt-0.5 text-xs leading-relaxed text-foreground-500">{a.desc}</p>
            </div>
            <i className="ri-arrow-right-s-line text-foreground-400 transition group-hover:text-primary-600"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}